export const sudsSitesSource = {
  id: "suds-sites",
  type: "geojson",
  // data: "https://gis2.london.gov.uk/server/rest/services/apps/SUDS_crowdsource_public_version_service_01/MapServer/0/query/?where=1%3D1&outfields=*&f=geojson",
  data: "https://gis2.london.gov.uk/server/rest/services/apps/SUDS_public_map_service/MapServer/0/query/?where=1%3D1&outfields=*&f=geojson",
};

export const catchmentPartnershipSource = {
  id: "catchment-partnership",
  type: "geojson",
  data: "https://gis2.london.gov.uk/server/rest/services/apps/SUDS_public_map_service/MapServer/1/query/?where=1%3D1&outfields=*&f=geojson",
};

export const giglOpenSpaceSource = {
  id: "gigl-open-space",
  type: "raster",
  tiles: [
    "https://gis2.london.gov.uk/server/rest/services/apps/SUDS_crowdsource_public_version_gigl_open_space/MapServer/tile/{z}/{y}/{x}",
  ],
};

export const thamesCombinedSource = {
  id: "thames-combined",
  type: "geojson",
  data: "https://gis2.london.gov.uk/server/rest/services/apps/SUDS_public_map_service/MapServer/3/query/?where=1%3D1&outfields=*&f=geojson",
};

export const thamesSeperateSource = {
  id: "thames-separate",
  type: "geojson",
  data: "https://gis2.london.gov.uk/server/rest/services/apps/SUDS_public_map_service/MapServer/4/query/?where=1%3D1&outfields=*&f=geojson",
};

export const watercoursesSource = {
  id: "watercourses",
  type: "geojson",
  data: "https://gis2.london.gov.uk/server/rest/services/apps/SUDS_public_map_service/MapServer/5/query/?where=1%3D1&outfields=*&f=geojson",
};

export const boroughSource = {
  id: "borough",
  type: "geojson",
  data: "https://gis2.london.gov.uk/server/rest/services/apps/webmap_context_layer/MapServer/3/query/?where=1%3D1&outfields=*&f=geojson",
};
